// General
import React, { useState, useContext, useRef } from "react";

// Context
import { SuppliersContext } from "../data/suppliers/SuppliersContext";
import { useData } from "../data/general/DataContext";
// Core Components
import TablePage from "../core/TablePage";

// Modals
import SuppliersAddModal from "../modals/suppliers/SuppliersAddModal";
import SuppliersUpdateModal from "../modals/suppliers/SuppliersUpdateModal";

// PrimeReact Components
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

// Icons
import { FaTrash, FaPencilAlt } from "react-icons/fa";

function SuppliersPage() {
    // Contextten tedarikçi verilerini ve silme fonksiyonunu al
    const { suppliersList, deleteSupplier } = useContext(SuppliersContext);
    const { windowMode } = useData();
    // Modal ve seçili tedarikçi state'leri
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);

    // Arama çubuğu için state
    const [searchTerm, setSearchTerm] = useState("");

    const ActionMenu = ({ rowData }) => {
        const op = useRef(null);
        if (windowMode === "mobile") return null;
        return (
            <>
                <Button
                    label="..."
                    className="p-button-rounded p-button-text"
                    style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
                    onClick={(e) => op.current.toggle(e)}
                />
                <OverlayPanel ref={op} dismissable showCloseIcon={false}>
                    <div className="flex flex-col gap-0 p-2 w-32">
                        {/* Düzenle butonu */}
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="p-button-text w-full justify-start"
                            onClick={() => {
                                setSelectedSupplier(rowData);
                                setShowUpdateModal(true);
                                op.current.hide();
                            }}
                        />
                        <div className="w-full border-t border-gray-300 my-1"></div>
                        {/* Sil butonu */}
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="p-button-text w-full justify-start"
                            style={{ color: "red" }}
                            onClick={() => {
                                deleteSupplier(rowData.id);
                                op.current.hide();
                            }}
                        />
                    </div>
                </OverlayPanel>
            </>
        );
    };

    // Tablo kolonları
    const columns = [
        { field: "id", header: "ID", hideInFilter: true },
        { field: "supplierName", header: "Tedarikçi Adı" },
        { field: "dealerName", header: "Bayi Adı" },
        { field: "status", header: "Durum" },
        {
            header: "İşlemler",
            body: (rowData) =>
                windowMode === "mobile" ? (
                    // Mobil görünümde direkt butonlar
                    <div className="flex gap-2 mt-2 w-full">
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="flex-1"
                            style={{
                                backgroundColor: "#3b82f6",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                            }}
                            onClick={() => {
                                setSelectedSupplier(rowData);
                                setShowUpdateModal(true);
                            }}
                        />
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="flex-1"
                            style={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                            }}
                            onClick={() => deleteSupplier(rowData.id)}
                        />
                    </div>
                ) : (
                    <ActionMenu rowData={rowData} />
                ),
            hideInFilter: true,
        },
    ];

    // Arama ile filtreleme
    const filteredSuppliers = suppliersList.filter(
        (s) =>
            !searchTerm ||
            s.supplierName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            s.dealerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            s.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Kolon filtreleme ayarları
    const columnFilterOptions = {
        supplierName: { type: "text" },
        dealerName: { type: "text" },
        status: { type: "text" },
    };

    return (
        <>
            <div className="p-6">
                <TablePage
                    title="Tedarikçi Listesi"
                    subTitle="Tedarikçi ekleyebilir, düzenleyebilir veya silebilirsiniz."
                    columns={columns}
                    data={filteredSuppliers}
                    defaultRows={10}
                    rowsPerPageOptions={[10, 15, 25, 50,100]}
                    showSearch
                    searchValue={searchTerm}
                    onSearchChange={(e) => setSearchTerm(e.target.value)}
                    onAdd={() => setShowAddModal(true)}
                    columnFilterOptions={columnFilterOptions}
                />
            </div>

            {/* Ekleme ve Güncelleme Modalları */}
            <SuppliersAddModal isOpen={showAddModal} onClose={() => setShowAddModal(false)} />
            <SuppliersUpdateModal
                isOpen={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                supplierId={selectedSupplier ? selectedSupplier.id : null}
            />
        </>
    );
}

export default SuppliersPage;
